<script setup>
import { onMounted, ref, computed } from "vue";
import { useUrl } from "@/composables/useUrl";
import RutaDetail from "./rutas/RutaDetail.vue";
import RutasPoint from "./rutas/RutasPoint.vue";
import Textarea from "primevue/textarea";
// import ToggleButton from "primevue/togglebutton";
import { useDb } from "@/composables/useDb";
import WaitingBible from "@/components/WaitingBible.vue";
import { useAppToast } from "@/composables/useAppToast";

let mapBase = null;
const center = ref();
const { getQuery, getItemFromQuery } = useUrl();

const items = ref([]);
const rutas = ref([]);
const rutasVisible = ref(false);
const activeRoute = ref(null);
const isLoading = ref(true);
const realtimeLocation = ref(false);
const mapIframe = ref(null);
const errorMessage = ref(null);
const waiting = ref(true);
const observaciones = ref("");
const showInformar = ref(false);
const puntoEncuentro = ref(null);

const { readDoc } = useDb();
const toast = useAppToast();

const ready = (mapBaseValue) => {
  // console.log("ready", mapBaseValue);
  mapBase = mapBaseValue;
  prepareMap();
};

const prepareMap = async () => {
  for (let i in items.value) {
    // console.log("items.value[i]", items.value[i]);
    if (!items.value[i].pendiente) {
      items.value[i].pendiente = await mzNumbers(items.value[i]);
    }
    // console.log("item.value[i]", items.value[i])
    setManzanas(items.value[i]);
  }

  mapBase.map().setZoom(15);
  addPuntoEncuentro();

  setWorked();
  isLoading.value = false;
};

const mzNumbers = (item) => {
  let obj = {};
  for (let i in item.mzNumbers) {
    if (i == 0) continue;
    // console.log("data.mzNumbers[i]", data.mzNumbers[i])
    obj[i] = false;
  }
  return obj;
};

const sendWhatsappRuta = () => {
  let rutaNumber = parseInt(activeRoute.value.index) + 1;
  const territorio = `${activeRoute.value.zona || ""}${
    activeRoute.value.numero
  }`;

  let msg = `Hola hermano, le informo que terminamos la ruta *${rutaNumber}* (${activeRoute.value.name}) del territorio *${territorio}*.\n\n¡Gracias!`;

  window.open(
    "https://api.whatsapp.com/send?text=" + encodeURIComponent(msg),
    "_blank"
  );
};
const sendWhatsapp = () => {
  let trabajado = "";
  for (let i in items.value) {
    const zona = items.value[0].zona || "";
    const manzanasTrue = [];
    const work = items.value[i].worked;
    for (let k in work) {
      if (work[k]) manzanasTrue.push(parseInt(k));
    }
    trabajado += `*${zona}${
      items.value[i].numero
    }*\n*Manzanas*: ${manzanasTrue.join(", ")}\n\n`;
  }

  const notasWp = observaciones.value
    ? `*Observaciones*:\n${observaciones.value.trim()}\n\n`
    : "";

  // ${getLinkInforme(
  //   data,
  //   worked.value
  // )}
  let msg = `Hola hermano, le informo lo trabajado.\n\n${trabajado}\n\n${notasWp}¡Gracias!`;

  window.open(
    "https://api.whatsapp.com/send?text=" + encodeURIComponent(msg),
    "_blank"
  );
};
// const getSrc = () => {
//   // const src = ref('/mapa.html?showLimits=1&center='+item.value.center+'&zoom='+item.value.zoom+'&limits='+JSON.stringify(item.value.limits)+'&mzNumbers='+JSON.stringify(item.value.mzNumbers));
//   return (
//     "/mapa.html?showLimits=1&center=" +
//     items.value.center +
//     "&zoom=" +
//     items.value.zoom +
//     "&limits=" +
//     JSON.stringify(items.value.limits) +
//     "&mzNumbers=" +
//     JSON.stringify(items.value.mzNumbers)
//   );
// };
const obtenerUbicacion = () => {
  if ("geolocation" in navigator) {
    navigator.geolocation.getCurrentPosition(
      function (position) {
        var latitude = position.coords.latitude;
        var longitude = position.coords.longitude;

        const yourLocation = [latitude, longitude];
        // console.log("yourLocation", yourLocation, mapBase);
        mapBase
          .m()
          .L.marker(yourLocation, {
            icon: L.icon({
              iconUrl: `p2.png`,
              iconSize: [32, 32],
              alt: "Tu ubicación",
            }),
          })
          .addTo(mapBase.map());

        center.value = [...yourLocation];
        // console.log("center.value", center.value);
        // console.log("mapBase.map()", mapBase);
        mapBase
          .map()
          .setView(new L.LatLng(yourLocation[0], yourLocation[1]), 14);

        // alert("Latitud: " + latitude + ", Longitud: " + longitude);
      },
      function (error) {
        // Si ocurre un error al obtener la ubicación
        toast.error("No se pudo obtener la ubicación", error.message);
      }
    );
  } else {
    toast.warn("Geolocalización no disponible", "Tu navegador no la admite.");
  }
};
// console.log("color", item.value.color)
// sessionStorage.setItem("color", JSON.stringify(items.value.color));

const getManzanaStyle = (item, status) => {
  // console.log("item", item, status);
  const color = item.color;
  if (!color) return "";
  if (status === false)
    return `color: ${color.color}; background: ${color.backgroundColor}; border: ${color.backgroundColor} 1px solid; `;
  return `border: ${color.backgroundColor} 1px solid; `;
};

const setManzanas = (item) => {
  let manzanas = item.mzNumbers;
  let numbers = [];

  const colors = getManzanaStyle(item);
  // console.log("colors", colors);
  const poligonColor = item.color?.backgroundColor
    ? item.color?.backgroundColor
    : "red";
  var polygon = L.polygon(item.limits, {
    color: poligonColor,
    opacity: 0.1,
  }).addTo(mapBase.map());

  for (let key in manzanas) {
    if (parseInt(key) === 0) continue;
    // console.log("item.center", item.center)
    // let label = showMzaNro.value ? key : item.zona+item.numero

    const opacity = item.pendiente.includes(parseInt(key)) ? 1 : 0.3;

    let label = key;
    let icon = L.divIcon({
      className: "manzana-marker ",
      iconSize: null,
      html: `<div class="icon manzana-marker-center" style="font-size: 1em; ${colors} opacity: ${opacity};">${label}</div><div class="arrow" />`,
    });
    numbers.push(mapBase.m().L.marker(manzanas[key][0], { icon }));
  }

  L.layerGroup(numbers).addTo(mapBase.map());
};

// let puntoEncuentro = query.puntoEncuentro
//   ? JSON.parse(query.puntoEncuentro)
//   : false;
const addPuntoEncuentro = () => {
  // const puntoEncuentro = query.puntoEncuentro
  //   ? JSON.parse(query.puntoEncuentro)
  //   : false;
  if (!puntoEncuentro.value?.latlng) return;
  const list = [];
  const icon = L.icon({
    iconUrl: `/pe.png`,
    iconSize: [32, 32],
    alt: "Punto de Encuentro",
  });
  list.push(mapBase.m().L.marker(puntoEncuentro.value?.latlng, { icon }));

  L.layerGroup(list).addTo(mapBase.map());
};

const setWorked = () => {
  for (let i in items.value) {
    let manzanas = mzNumbers(items.value[i]);
    // console.log("manzanas", manzanas)
    for (let k in manzanas) {
      if (!items.value[i].pendiente.includes(parseInt(k))) {
        delete manzanas[k];
      }
    }

    items.value[i].worked = manzanas;
  }
};

const getData = async () => {
  try {

    waiting.value = true;
    const query = await getQuery();
    // console.log("query", query);
    const type = query.type || "maps";
    const { data: doc, error } = await readDoc(query.domain, type, query.doc, query.key);
    if (error) {
      errorMessage.value = error;
      return;
    }
    if (type === "links") {
      const { lat, lng } = doc?.puntosEncuentro?.latlng;
      const link = `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`;
      window.location.href = link;
      return;
    }

    puntoEncuentro.value = doc.puntoEncuentro;
    // console.log("doc", doc);
    const allItems = await getItemFromQuery(doc);
    // console.log("allItems", allItems);
    items.value = allItems.filter((i) => !i.tipo || i.tipo === "default");
    rutas.value = allItems
      .filter((i) => i.tipo === "routes")
      .map((i) => (typeof i === "string" ? JSON.parse(i) : i));

    if (!Array.isArray(items.value) || items.value.length === 0) {
      if (rutas.value.length > 0) {
        rutasVisible.value = true;
      }
      waiting.value = false;
      return;
    }

    const centerManzana =
      items.value[0]?.mzNumbers.length > 0
        ? items.value[0]?.mzNumbers[0][0]
        : false;

    center.value = items.value[0].center || centerManzana;
    waiting.value = false;
  }
  catch (e) {
    console.error("Error", e);
  }

}

onMounted(async () => {
  getData();
});

const srcRoute = computed(() => {
  if (!activeRoute.value) return "";
  const center =
    activeRoute.value.route[0][0] + "," + activeRoute.value.route[0][1];
  return (
    "/mapa.html?type=route&center=" +
    center +
    "&zoom=" +
    activeRoute.value.zoom +
    "&route=" +
    JSON.stringify(activeRoute.value.route) +
    "&points=" +
    JSON.stringify(activeRoute.value.points)
  );
});

const selectRoute = (territorio, route, index) => {
  // rutasVisible.value = false;
  activeRoute.value = {
    ...territorio,
    ...route,
    index,
  };
};

const getLocation = () =>
  new Promise((resolve, reject) => {
    if ("geolocation" in navigator) {
      // console.log("navigator.geolocation", navigator.geolocation);
      navigator.geolocation.getCurrentPosition(
        function (position) {
          var latitude = position.coords.latitude;
          var longitude = position.coords.longitude;

          const yourLocation = [latitude, longitude];
          // console.log("yourLocation", yourLocation);
          resolve(yourLocation);
        },
        function (error) {
          toast.warn(
            "Ubicación no disponible",
            "Tu navegador no la admite o no diste permiso de acceso."
          );
          reject(false);
        }
      );
    } else {
      toast.warn("Geolocalización no disponible", "Tu navegador no la admite.");
      reject(false);
    }
  });

const sendLocationToIframe = async () => {
  if (!realtimeLocation.value) return;
  const latLng = await getLocation();
  if (!latLng) return;
  mapIframe.value.contentWindow.postMessage({
    call: "realtimeLocation",
    value: latLng,
  });
};

let realtimeInterval = false;
const obtenerUbicacionRealtime = async () => {
  if (realtimeLocation.value) {
    if (realtimeInterval) clearInterval(realtimeInterval);
    mapIframe.value.contentWindow.postMessage({
      call: "realtimeLocation",
      value: false,
    });
    realtimeLocation.value = false;
    return;
  }
  if (realtimeInterval) clearInterval(realtimeInterval);
  realtimeLocation.value = true;
  sendLocationToIframe();
  realtimeInterval = setInterval(async () => {
    sendLocationToIframe();
  }, 10000);
};
</script>

<template>
  <div v-if="waiting">
    <WaitingBible :error="errorMessage" />
  </div>
  <div class="grid grid-nogutter align-content-start text-left viewer" v-else>
    <div class="col-12 lg:col-6 px-2 lg:px-4 pb-3 bg-white">
      <div class="flex justify-content-between items-content-center mt-3 mb-3">
        <h1 class="font-light m-0">¡Bienvenido!</h1>

        <div v-if="rutas.length > 0">
          <Button
            label="Rutas"
            severity="contrast"
            @click="
              rutasVisible = !rutasVisible;
              activeRoute = null;
            "
            outline
            v-if="!rutasVisible && items.length > 0"
          />
          <Button
            label="Ocultar Rutas"
            @click="
              rutasVisible = !rutasVisible;
              activeRoute = null;
            "
            severity="contrast"
            v-if="rutasVisible && !activeRoute && items.length > 0"
          />
          <Button
            label="Volver"
            severity="contrast"
            @click="activeRoute = null"
            v-if="activeRoute && rutasVisible"
          />
        </div>
      </div>

      <div class="manzanas" v-if="items.length > 0 && !rutasVisible">
        <h3 class="py-0 mt-1 mb-2 text-sm font-light">
          Las manzanas/zonas asignadas del territorio son las siguientes:
        </h3>
        <div v-for="(item, key) in items" class="mt-3">
          <div class="flex gap-2">
            <div>
              <h1
                class="m-0 p-1 px-2 font-light text-lg border-round-sm"
                :style="getManzanaStyle(item, false)"
              >
                {{ item.zona }}{{ item.numero }}
              </h1>
            </div>
            <div class="m-0 pb-1">
              <h2 class="m-0 p-0 text-sm">{{ item.referencia }}</h2>
              <div class="text-xs">
                {{ item.notas }}
              </div>
            </div>
          </div>

          <div class="grid grid-nogutter mt-2">
            <div v-for="(check, k) in item.worked" :key="k" class="mr-2 mb-2">
              <!-- :style="getManzanaStyle(item, item.worked[k])" -->
              <div
                class="py-1 px-3 border-1 border-round-sm text-center cursor-pointer"
                :style="getManzanaStyle(item, !check)"
                @click="item.worked[k] = !item.worked[k]"
              >
                {{ k }}
              </div>
            </div>
          </div>
        </div>
        <!-- INFORMAR -->
        <div v-if="!showInformar" class="mt-3">
          <Button
            label="Informar"
            severity="secondary"
            outlined
            @click="showInformar = true"
          />
        </div>
        <div v-if="showInformar" class="mt-3">
          <div>
            <Textarea
              v-model="observaciones"
              placeholder="Observaciones"
              rows="5"
              cols="30"
            />
          </div>

          <div class="pt-2">
            <Button
              label="Enviar Mensaje"
              severity="success"
              class="p-button-success"
              @click="sendWhatsapp"
            />
          </div>
          <div class="text-sm mt-3">
            Seleccione las manzanas que han sido trabajadas y toque "Enviar
            Mensaje" para informar lo trabajado.
          </div>
          <!-- <div>{{ item }}</div> -->
        </div>
        <!-- FIN INFORMAR -->
        <p class="text-red-600 text-xs m-0 p-0 mt-3">
          Los nombres de territorios solo son de referencía, el territorio no es
          por barrio. El territorio son todas las zonas numeradas que se
          muestran en el mapa.
        </p>
      </div>

      <div v-if="rutasVisible && !activeRoute">
        <h3 class="py-0 mt-1 mb-2 text-sm font-light">
          Seleccione la ruta a trabajar:
        </h3>
        <div v-for="territorio in rutas" :key="territorio.id">
          <!-- {{ territorio }} -->
          <div
            class="flex gap-2 border-round-sm"
            :style="getManzanaStyle(territorio, false)"
          >
            <h1 class="m-0 p-1 px-2 font-light text-lg">
              {{ territorio.zona }}{{ territorio.numero }}
            </h1>
            <div class="m-0 py-1">
              <h2 class="m-0 p-0 text-sm">{{ territorio.referencia }}</h2>
              <div class="text-xs">
                {{ territorio.notas }}
              </div>
            </div>
          </div>
          <div v-for="(route, index) in territorio.routes" :key="route.id">
            <RutaDetail
              :doc="{
                ...route,
                index,
              }"
              @click="selectRoute(territorio, route, index)"
              :full="true"
            />
          </div>
        </div>
      </div>
      <div v-if="rutasVisible && activeRoute">
        <div
          class="flex gap-2 border-round-sm"
          :style="getManzanaStyle(activeRoute, false)"
        >
          <h1 class="m-0 p-1 px-2 font-light text-lg">
            {{ activeRoute.zona }}{{ activeRoute.numero }}
          </h1>
          <div class="m-0 py-1">
            <h2 class="m-0 p-0 text-sm">{{ activeRoute.referencia }}</h2>
            <div class="text-xs">
              {{ activeRoute.notas }}
            </div>
          </div>
        </div>
        <div class="my-3">
          <div class="text-sm font-bold">
            Ruta {{ parseInt(activeRoute.index) + 1 }}
          </div>
          {{ activeRoute.name }}
        </div>
        <div class="flex flex-column gap-2">
          <div v-for="(point, index) in activeRoute.points" :key="index">
            <RutasPoint
              :doc="point"
              :index="index"
              :link="true"
              @refreshPoint="refreshPoint"
            />
          </div>
        </div>

        <div class="flex gap-2 mt-3">
          <!-- severity="success" -->
          <Button
            label="Ruta Completada"
            severity="secondary"
            text
            @click="sendWhatsappRuta"
          />
        </div>
      </div>
    </div>
    <!-- SECCION MAPA -->
    <div
      class="col-12 grid grid-nogutter title surface-200 pb-10"
      v-if="!rutasVisible || (rutasVisible && activeRoute)"
    >
      <div
        class="col-12 lg:col-6 pt-0 px-1 py-2 pb-2 lg:px-2 flex justify-content-between"
      >
        <div class="w-full">
          <div class="">
            <h1 class="font-light mt-2 mb-3">Mapa</h1>
          </div>

          <!-- botones -->
          <div
            class="flex align-items-center justify-content-start w-full mb-1 gap-2"
          >
            <Button
              icon="pi pi-map-marker"
              label="¿Dónde estoy?"
              severity="warning"
              @click="obtenerUbicacion"
              v-if="!rutasVisible"
            />
            <a
              v-if="puntoEncuentro && !rutasVisible"
              :href="`https://www.google.com/maps/search/?api=1&query=${puntoEncuentro.latlng.lat},${puntoEncuentro.latlng.lng}`"
              target="_blank"
              class="flex align-items-center gap-2 bg-indigo-300 p-2 px-3 no-underline border-round-sm text-white"
            >
              <img src="/pe.png" style="height: 1.3rem" />
              ¿Cómo llegar?</a
            >
            <div v-if="rutasVisible">
              <Button
                label="Ver mi ubicación"
                icon="pi pi-map-marker"
                severity="warning"
                @click="obtenerUbicacionRealtime"
                v-if="!realtimeLocation"
              />
              <Button
                label="Ocultar mi ubicación"
                icon="pi pi-map-marker"
                severity="secondary"
                @click="obtenerUbicacionRealtime"
                v-else
              />
            </div>
          </div>
        </div>
        <div></div>
      </div>
    </div>

    <div
      class="col-12 lg:col-6 pr-2 pl-1 relative surface-200"
      v-if="!rutasVisible || (rutasVisible && activeRoute)"
    >
      <div class="absolute" style="top: 10px; right: 10px; z-index: 999">
        <img src="/north.png" style="width: 3rem; min-height: 3rem" />
      </div>
      <!-- <iframe
        :src="getSrc"
        frameborder="0"
        class="map-iframe"
        v-if="!Array.isArray(items) "
      ></iframe> -->

      <div v-if="rutasVisible && activeRoute">
        <iframe
          :src="srcRoute"
          frameborder="0"
          class="map-iframe"
          ref="mapIframe"
        ></iframe>
      </div>

      <div v-if="!rutasVisible && center" class="p-0 m-0 mb-4">
        <MapaBase
          class="map-iframe"
          :center="center"
          :search="false"
          :saveCenter="false"
          @ready="ready"
        ></MapaBase>
      </div>
    </div>
  </div>
</template>

<style scoped>
.title {
  /* max-height: 5em; */
}
.viewer {
  background-color: rgb(255, 255, 255);
  min-height: 100vh;
  width: 100vw;
}
.map-iframe {
  width: 99%;
  height: 70vh !important;
  margin-left: 0.5%;
}

.p-button.p-button-contrast,
.p-button-group.p-button-contrast > .p-button,
.p-splitbutton.p-button-contrast > .p-button {
  color: #ffffff;
  background: #020617;
  border: 1px solid #020617;
}
</style>
